// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1G0xa","actionsCol":"EnrolledClinics_actionsCol__3oWF_"};